import { css, cx } from '@eti/styles';
import { breakpoints, vars } from '@etg/wings';
export const wrapperStyles = css`
  border-block: 1px solid ${vars.colors.divider};
  display: flex;
  flex-flow: column wrap;
  margin-inline: -16px;
  padding: 0;

  ul > *:not(:last-child) {
    margin-bottom: 8px;
  }

  @media (min-width: ${breakpoints._768}) {
    margin-inline-start: 0;
  }
`;
export const clickableArea = css`
  align-items: center;
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  display: flex;
  flex: 1;
  justify-content: space-between;
  padding: 16px;
  z-index: 1;
`;
export const fontSize = css`
  & li:not(:last-child) {
    margin-bottom: 8px;
  }

  @media (min-width: ${breakpoints._768}) {
    font-size: 0.875rem;
  }
`;
export const toggleIconStyles = open => css`
  transform: rotateX(${open ? '180deg' : '0deg'});
  transition: transform 0.2s ease-in-out;
`;
export const readMoreTextBase = iconContent => css`
  ul {
    li {
      padding-inline-start: 12px;
      &::before {
        left: 0;
        margin-right: 8px;
        position: absolute;
      }
    }
  }

  a {
    position: relative;

    + p {
      margin-top: 16px;
    }

    &::after {
      content: ${iconContent !== null && iconContent !== void 0 ? iconContent : ''};
    }
  }
`;
export const contentText = iconContent => cx(readMoreTextBase(iconContent), css`
      margin-bottom: 16px;
      padding-inline: 24px 16px;

      > *:not(:last-child) {
        margin-bottom: 16px;
      }

      ul {
        li {
          list-style-position: inside;
          &::before {
            background-color: ${vars.colors.text.primary};
          }
        }
      }

      & a {
        color: ${vars.colors.links.default};

        &.link {
          display: block;
          margin-bottom: 0;
          width: fit-content;
        }

        &::after {
          bottom: 6px;
          display: inline-block;
          height: 16px;
          margin-inline-start: 4px;
          position: relative;
          vertical-align: bottom;
          width: 16px;
        }
      }
    `);
export const readMoreContentStyles = css`
  display: grid;
  overflow: hidden;
`;
export const standardGrid = css`
  display: grid;

  .text {
    grid-area: 1 / 1 / 2 / 2;
  }

  .children {
    display: contents;
  }
`;
//# sourceMappingURL=styles.js.map